import React, {useState, useEffect,Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import Color from "color";

import TemplatePROHeader from "./templates/BASE/TemplatePROHeader";
import Template1BLocalisation from "./templates/BASE/Template1BLocalisation";
import TemplateErpCatnat from "./templates/ERP/TemplateERP_catnat";
import Template1BCadastral from "./templates/BASE/Template1BCadastral";
import Template1BSynthese from "./templates/BASE/Template1BSynthese";
import Template1BRisque from "./templates/BASE/Template1BRisque";

const ERPForm = (props) => {

    const [isLoading, setIsLoading] = useState(false)
    const [displayForm, setDisplayForm] = useState("base")
    const [primaryCol, setPrimaryCol] = useState(Color("#770866"))


    useEffect((e)=>{
        setDisplayForm("erp")
    }, [])

    return (
        (isLoading)
        ?<div className="text-center my-2"><Spinner animation="border" size={'sm'}/></div>
        :<div className={'container eu-form'} id={"eu-data"}>
            <form action="">
                <TemplatePROHeader />
                <div className="ue-section ue-form-title" style={{"backgroundColor": primaryCol.hex()}}>
                    <span>ÉTAT DES RISQUES NATURELS ET POLLUTIONS</span>
                </div>
                <Template1BCadastral primColor={primaryCol}/>
                <Template1BLocalisation screenCapt={props.screenCapt}/>
                <Template1BSynthese formtype={displayForm} primColor={primaryCol}/>
                <div className="page-break"></div>
                <Template1BRisque formtype={displayForm} primColor={primaryCol}/>
                <TemplateErpCatnat insee={'2A004'} primColor={primaryCol}/>
            </form>
        </div>
    );
};



export default ERPForm;
